import {Injectable} from "@angular/core";
import {catchError, Observable} from "rxjs";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import {NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";
import {environment} from "../../../../environments/environment";
import {JwtService} from "../jwt/jwt.service";
import {ToastService} from "../toast/toast.service";

@Injectable({providedIn: 'root'})
export class ResetPasswordService {
    private baseEndpoint: string;
    token: any;
    private body: any;
    private passwordRequest;

    constructor(private http: HttpClient,
                private router: Router,
                private modalService: NgbModal,
                private modalConfig: NgbModalConfig,
                private jwtService: JwtService,
                private toastService: ToastService
    ) {
        this.baseEndpoint = environment.apiUser
        modalConfig.backdrop = 'static';
        modalConfig.keyboard = false;
    }

    validateToken(sToken: string): Observable<any> {
        this.body = {
            code: sToken
        }
        return this.http.post<any>(`${this.baseEndpoint}/password/validate/token/email`, this.body)
    }

    public savePassword(psw: String, jwt: string | null): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization-Banca-Pass', jwt + "");
        return this.http.post<any>(`${this.baseEndpoint}/password/restore`, {passNuevo: psw}, {headers: headers});
    }


    closeModal() {
        this.close;
    }

    close() {
        this.close;
    }

    changeAuthPassword(otp, translations) {
        const url = `${this.baseEndpoint}/password/change`
        const jwt = this.jwtService.signRequest("operacion", {
            passActual: this.passwordRequest.currentPassword,
            passNuevo: this.passwordRequest.newPassword
        }, otp);
        return this.http.post(url, {jwt}).pipe(catchError((error: HttpErrorResponse) => {
            const errorMessage = translations.error
            this.toastService.showToast(errorMessage)
            throw error;
        }))

    }


    setPassword(currentPassword, newPassword) {
        this.passwordRequest = {currentPassword, newPassword};
    }
}
